"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundFilterMonitor = void 0;
var loader_1 = require("../../libs/voicefocus/loader");
var CanvasVideoFrameBuffer_1 = require("../videoframeprocessor/CanvasVideoFrameBuffer");
var BackgroundFilterFrameCounter_1 = require("./BackgroundFilterFrameCounter");
/** @internal */
var DeferredObservable = /*#__PURE__*/function () {
  function DeferredObservable() {
    _classCallCheck(this, DeferredObservable);
    /** Access the last-resolved value of next()
     */
    this.value = undefined;
    this.resolve = null;
  }
  /** Create a promise that resolves once next() is called
   */
  _createClass(DeferredObservable, [{
    key: "whenNext",
    value: function whenNext() {
      var _this = this;
      /* istanbul ignore else */
      if (!this.promise) {
        // externally-resolvable promise
        this.promise = new Promise(function (resolve) {
          return _this.resolve = resolve;
        });
      }
      return this.promise;
    }
    /** Update the value and resolve
     */
  }, {
    key: "next",
    value: function next(value) {
      // store the value, for sync access
      this.value = value;
      // resolve the promise so anyone awaiting whenNext resolves
      this.resolve(value);
      // delete the promise so future whenNext calls get a new promise
      delete this.promise;
    }
  }]);
  return DeferredObservable;
}();
/**
 * The [[BackgroundFilterProcessor]] uses WASM and TensorFlow Lite to apply changes to the
 * background image.
 */
/** @internal */
var BackgroundFilterProcessor = /*#__PURE__*/function () {
  function BackgroundFilterProcessor(filterType, spec, options, delegate) {
    _classCallCheck(this, BackgroundFilterProcessor);
    this.targetCanvas = document.createElement('canvas');
    this.canvasCtx = this.targetCanvas.getContext('2d');
    this.canvasVideoFrameBuffer = new CanvasVideoFrameBuffer_1.default(this.targetCanvas);
    this.mask$ = new DeferredObservable();
    this.sourceWidth = 0;
    this.sourceHeight = 0;
    this.frameNumber = 0;
    this.videoFramesPerFilterUpdate = 1;
    this.initWorkerPromise = BackgroundFilterProcessor.createWorkerPromise();
    this.loadModelPromise = BackgroundFilterProcessor.createWorkerPromise();
    this.modelInitialized = false;
    this.destroyed = false;
    this.filterType = filterType;
    this.validateSpec(spec);
    this.validateOptions(options);
    this.spec = spec;
    this.logger = options.logger;
    this.delegate = delegate;
    this.initCPUMonitor(options);
  }
  _createClass(BackgroundFilterProcessor, [{
    key: "validateSpec",
    /** Check if the input spec are not null
     */
    value: function validateSpec(spec) {
      if (!spec) {
        throw new Error('processor has null spec');
      }
      if (!spec.model) {
        throw new Error('processor spec has null model');
      }
      if (!spec.paths) {
        throw new Error('processor spec has null paths');
      }
    }
  }, {
    key: "validateOptions",
    value: function validateOptions(options) {
      if (!options) {
        throw new Error('processor has null options');
      }
      if (!options.logger) {
        throw new Error('processor has null options - logger');
      }
      if (!options.reportingPeriodMillis) {
        throw new Error('processor has null options - reportingPeriodMillis');
      }
      if (!options.filterCPUUtilization) {
        throw new Error('processor has null options - filterCPUUtilization');
      }
    }
  }, {
    key: "initCPUMonitor",
    value: function initCPUMonitor(options) {
      var _this2 = this;
      var CPU_MONITORING_PERIOD_MILLIS = 5000;
      var MAX_SEGMENTATION_SKIP_RATE = 10;
      var MIN_SEGMENTATION_SKIP_RATE = 1;
      this.videoFramesPerFilterUpdate = 1;
      this.frameCounter = new BackgroundFilterFrameCounter_1.default(this.delegate, options.reportingPeriodMillis, options.filterCPUUtilization, this.logger);
      this.cpuMonitor = new BackgroundFilterMonitor(CPU_MONITORING_PERIOD_MILLIS, {
        reduceCPUUtilization: function reduceCPUUtilization() {
          _this2.updateVideoFramesPerFilterUpdate(Math.min(_this2.videoFramesPerFilterUpdate + 1, MAX_SEGMENTATION_SKIP_RATE));
        },
        increaseCPUUtilization: function increaseCPUUtilization() {
          _this2.updateVideoFramesPerFilterUpdate(Math.max(_this2.videoFramesPerFilterUpdate - 1, MIN_SEGMENTATION_SKIP_RATE));
        }
      });
      this.delegate.addObserver(this.cpuMonitor);
    }
    /** Converts a value to a JSON string
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "stringify",
    value: function stringify(value) {
      return JSON.stringify(value, null, 2);
    }
    /**
     * Sends a message to worker and resolves promise in response to worker's initialize event
     */
  }, {
    key: "handleInitialize",
    value: function handleInitialize(msg) {
      this.logger.info("received initialize message: ".concat(this.stringify(msg)));
      if (!msg.payload) {
        this.logger.error('failed to initialize module');
        this.initWorkerPromise.reject(new Error('failed to initialize the module'));
        return;
      }
      var model = this.spec.model;
      this.worker.postMessage({
        msg: 'loadModel',
        payload: {
          modelUrl: model.path,
          inputHeight: model.input.height,
          inputWidth: model.input.width,
          inputChannels: 4,
          modelRangeMin: model.input.range[0],
          modelRangeMax: model.input.range[1],
          blurPixels: 0
        }
      });
      this.initWorkerPromise.resolve({});
    }
    /**
     * Resolves promise in response to worker's loadModel event
     */
  }, {
    key: "handleLoadModel",
    value: function handleLoadModel(msg) {
      this.logger.info("received load model message: ".concat(this.stringify(msg)));
      if (msg.payload !== 2) {
        this.logger.error('failed to load model! status: ' + msg.payload);
        /** Rejects model promise
         */
        this.loadModelPromise.reject(new Error('failed to load model! status: ' + msg.payload));
        return;
      }
      this.modelInitialized = true;
      this.loadModelPromise.resolve({});
    }
    /** Updates the payload output value in response to worker's predict event
     */
  }, {
    key: "handlePredict",
    value: function handlePredict(msg) {
      this.mask$.next(msg.payload.output);
    }
    /**
     * This method will handle the asynchronous messaging between the main JS thread
     * and the worker thread.
     * @param evt An event that was sent from the worker to the JS thread.
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "handleWorkerEvent",
    value: function handleWorkerEvent(evt) {
      var msg = evt.data;
      switch (msg.msg) {
        case 'initialize':
          this.handleInitialize(msg);
          break;
        case 'loadModel':
          this.handleLoadModel(msg);
          break;
        case 'predict':
          this.handlePredict(msg);
          break;
        default:
          this.logger.info("unexpected event msg: ".concat(this.stringify(msg)));
          break;
      }
    }
    /**
     * This method initializes all of the resource necessary to processs background filter. It returns
     * a promise and resolves or rejects the promise once the initialization is complete.
     * @returns
     * @throws An error will be thrown
     */
  }, {
    key: "loadAssets",
    value: function loadAssets() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.logger.info('start initializing the processor');
              _context.prev = 1;
              _context.next = 4;
              return loader_1.loadWorker(this.spec.paths.worker, 'BackgroundFilterWorker', {}, null);
            case 4:
              this.worker = _context.sent;
              this.worker.addEventListener('message', function (ev) {
                return _this3.handleWorkerEvent(ev);
              });
              this.worker.postMessage({
                msg: 'initialize',
                payload: {
                  wasmPath: this.spec.paths.wasm,
                  simdPath: this.spec.paths.simd
                }
              });
              _context.next = 9;
              return this.initWorkerPromise.promise;
            case 9:
              this.logger.info("successfully initialized the ".concat(this.filterType, " worker"));
              _context.next = 12;
              return this.loadModelPromise.promise;
            case 12:
              this.logger.info("successfully loaded ".concat(this.filterType, " worker segmentation model"));
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](1);
              throw new Error("could not initialize the ".concat(this.filterType, " video frame processor due to '").concat(_context.t0.message, "'"));
            case 18:
              this.logger.info("successfully initialized the ".concat(this.filterType, " processor"));
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 15]]);
      }));
    }
    /**
     * Processes the VideoFrameBuffer by applying a segmentation mask and replacing the background.
     * @param buffers object that contains the canvas element that will be used to obtain the image data to process
     * @returns the updated buffer that contains the image with the background replaced.
     */
  }, {
    key: "process",
    value: function process(buffers) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var inputCanvas, frameWidth, frameHeight, mask, hscale, vscale, scaledCtx, imageData, maskPromise;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.destroyed) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", buffers);
            case 2:
              this.frameCounter.frameReceived(buffers[0].framerate);
              this.cpuMonitor.frameReceived();
              inputCanvas = buffers[0].asCanvasElement();
              if (inputCanvas) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", buffers);
            case 7:
              if (this.modelInitialized) {
                _context2.next = 10;
                break;
              }
              // return existing buffer, if any
              buffers[0] = this.canvasVideoFrameBuffer;
              return _context2.abrupt("return", buffers);
            case 10:
              frameWidth = inputCanvas.width;
              frameHeight = inputCanvas.height;
              if (!(frameWidth === 0 || frameHeight === 0)) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", buffers);
            case 14:
              // on first execution of process the source width will be zero
              if (this.sourceWidth === 0) {
                this.sourceWidth = frameWidth;
                this.sourceHeight = frameHeight;
                // update target canvas size to match the frame size
                this.targetCanvas.width = this.sourceWidth;
                this.targetCanvas.height = this.sourceHeight;
                this.logger.info("".concat(this.filterType, " source width: ").concat(this.sourceWidth));
                this.logger.info("".concat(this.filterType, " source height: ").concat(this.sourceHeight));
                this.initOnFirstExecution();
              }
              if (this.sourceWidth !== frameWidth || this.sourceHeight !== frameHeight) {
                this.sourceWidth = frameWidth;
                this.sourceHeight = frameHeight;
                // update target canvas size to match the frame size
                this.targetCanvas.width = this.sourceWidth;
                this.targetCanvas.height = this.sourceHeight;
              }
              _context2.prev = 16;
              this.frameCounter.filterSubmitted();
              mask = this.mask$.value;
              hscale = this.spec.model.input.width / inputCanvas.width;
              vscale = this.spec.model.input.height / inputCanvas.height;
              if (this.scaledCanvas === undefined) {
                this.scaledCanvas = document.createElement('canvas');
                this.scaledCanvas.width = this.spec.model.input.width;
                this.scaledCanvas.height = this.spec.model.input.height;
              }
              scaledCtx = this.scaledCanvas.getContext('2d');
              scaledCtx.save();
              scaledCtx.scale(hscale, vscale);
              scaledCtx.drawImage(inputCanvas, 0, 0);
              scaledCtx.restore();
              imageData = scaledCtx.getImageData(0, 0, this.scaledCanvas.width, this.scaledCanvas.height); // update the filter mask based on the filter update rate
              if (!(this.frameNumber % this.videoFramesPerFilterUpdate === 0)) {
                _context2.next = 34;
                break;
              }
              // process frame...
              maskPromise = this.mask$.whenNext();
              this.worker.postMessage({
                msg: 'predict',
                payload: imageData
              }, [imageData.data.buffer]);
              _context2.next = 33;
              return maskPromise;
            case 33:
              mask = _context2.sent;
            case 34:
              // It's possible that while waiting for the predict to complete the processor was destroyed.
              // adding a destroyed check here to ensure the implementation of drawImageWithMask does not throw
              // an error due to destroyed processor.
              if (!this.destroyed) {
                this.drawImageWithMask(inputCanvas, mask);
              }
              _context2.next = 41;
              break;
            case 37:
              _context2.prev = 37;
              _context2.t0 = _context2["catch"](16);
              this.logger.error("could not process ".concat(this.filterType, " frame buffer due to ").concat(_context2.t0));
              return _context2.abrupt("return", buffers);
            case 41:
              _context2.prev = 41;
              this.frameCounter.filterComplete();
              this.frameNumber++;
              return _context2.finish(41);
            case 45:
              buffers[0] = this.canvasVideoFrameBuffer;
              return _context2.abrupt("return", buffers);
            case 47:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[16, 37, 41, 45]]);
      }));
    }
  }, {
    key: "updateVideoFramesPerFilterUpdate",
    value: function updateVideoFramesPerFilterUpdate(newRate) {
      if (newRate !== this.videoFramesPerFilterUpdate) {
        this.videoFramesPerFilterUpdate = newRate;
        this.logger.info("Adjusting filter rate to compensate for CPU utilization. " + "Filter rate is ".concat(this.videoFramesPerFilterUpdate, " video frames per filter."));
      }
    }
    /**
     * Clean up processor resources
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var _a, _b, _c, _d;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.destroyed = true;
              this.delegate.removeObserver(this.cpuMonitor);
              this.canvasVideoFrameBuffer.destroy();
              (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({
                msg: 'destroy'
              });
              (_b = this.worker) === null || _b === void 0 ? void 0 : _b.postMessage({
                msg: 'stop'
              });
              (_c = this.targetCanvas) === null || _c === void 0 ? void 0 : _c.remove();
              this.targetCanvas = undefined;
              (_d = this.scaledCanvas) === null || _d === void 0 ? void 0 : _d.remove();
              this.scaledCanvas = undefined;
              this.logger.info("".concat(this.filterType, " frame process destroyed"));
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }], [{
    key: "createWorkerPromise",
    value: function createWorkerPromise() {
      var resolver = {
        resolve: null,
        reject: null,
        promise: null
      };
      resolver.promise = new Promise(function (resolve, reject) {
        resolver.resolve = resolve;
        resolver.reject = reject;
      });
      return resolver;
    }
  }]);
  return BackgroundFilterProcessor;
}();
exports.default = BackgroundFilterProcessor;
/** @internal */
var BackgroundFilterMonitor = /*#__PURE__*/function () {
  function BackgroundFilterMonitor(monitoringPeriodMillis, observer) {
    _classCallCheck(this, BackgroundFilterMonitor);
    this.monitoringPeriodMillis = monitoringPeriodMillis;
    this.observer = observer;
    this.lastCPUChangeTimestamp = 0;
  }
  _createClass(BackgroundFilterMonitor, [{
    key: "filterCPUUtilizationHigh",
    value: function filterCPUUtilizationHigh() {
      var timestamp = Date.now();
      // Allow some time to pass before we check CPU utilization.
      if (timestamp - this.lastCPUChangeTimestamp >= this.monitoringPeriodMillis) {
        this.lastCPUChangeTimestamp = timestamp;
        this.observer.reduceCPUUtilization();
      }
    }
  }, {
    key: "frameReceived",
    value: function frameReceived() {
      var timestamp = Date.now();
      // If a enough time has passed, reset the processor and continue to monitor
      if (timestamp - this.lastCPUChangeTimestamp >= this.monitoringPeriodMillis * 2) {
        this.lastCPUChangeTimestamp = timestamp;
        this.observer.increaseCPUUtilization();
      }
    }
  }]);
  return BackgroundFilterMonitor;
}();
exports.BackgroundFilterMonitor = BackgroundFilterMonitor;